export default __webpack_public_path__ + "static/media/skye_kinder.95e0bd61.jpg";